import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const TOGGLE_UNDO_WHD_UPLOAD_MODAL = 'TOGGLE_UNDO_WHD_UPLOAD_MODAL';
export const UNDO_WHD_UPLOAD_REQUEST = 'UNDO_WHD_UPLOAD_REQUEST';
export const UNDO_WHD_UPLOAD_SUCCESS = 'UNDO_WHD_UPLOAD_SUCCESS';
export const UNDO_WHD_UPLOAD_FAILURE = 'UNDO_WHD_UPLOAD_FAILURE';

function openUndoWhdUploadModal(uploadId, originalFileName) {
  return {
    type: TOGGLE_UNDO_WHD_UPLOAD_MODAL,
    isUndoWhdUploadModalShown: true,
    undoWhdUploadId: uploadId,
    undoWhdUploadOriginalFileName: originalFileName
  };
}

function closeUndoWhdUploadModal() {
  return {
    type: TOGGLE_UNDO_WHD_UPLOAD_MODAL,
    isUndoWhdUploadModalShown: false,
    undoWhdUploadId: null,
    undoWhdUploadOriginalFileName: null
  };
}

export function showUndoWhdUploadModal(uploadId, originalFileName) {
  return (dispatch) => {
    dispatch(openUndoWhdUploadModal(uploadId, originalFileName));
  };
}

export function hideUndoWhdUploadModal() {
  return (dispatch) => {
    dispatch(closeUndoWhdUploadModal());
  };
}

function requestUndoWhdUpload() {
  return {
    type: UNDO_WHD_UPLOAD_REQUEST,
    isUndoingWhdUpload: true
  };
}

function successUndoWhdUpload() {
  return {
    type: UNDO_WHD_UPLOAD_SUCCESS,
    isUndoingWhdUpload: false
  };
}

function rejectUndoWhdUpload() {
  return {
    type: UNDO_WHD_UPLOAD_FAILURE,
    isUndoingWhdUpload: false
  };
}

export function undoWhdUpload(accountId, uploadId, callback) {
  return (dispatch) => {
    dispatch(requestUndoWhdUpload());

    const promise = () => ApiService
      .cancelWhdDocumentUpload(accountId, uploadId)
      .then((response) => {
        const action = dispatch(successUndoWhdUpload());
        if (callback) {
          callback();
        }
        dispatch(hideUndoWhdUploadModal());
        return action;
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectUndoWhdUpload, true));
        } else {
          dispatch(rejectUndoWhdUpload());
        }
      });

    return promise();
  };
}
